export class Product {
  id: number;
  name: string;
  amount?: number;
  is_it?: boolean;
  image?: string;
}
